export default __webpack_public_path__ + "static/media/solucao-10.c2be1b8d.webp";